export default "__VITE_ASSET__9jgSW8xX__"